"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _moment = babelHelpers.interopRequireDefault(require("moment"));

var _PeopleBlockList = babelHelpers.interopRequireDefault(require("components/PeopleBlockList"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp2, _class5, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp3, _class7, _descriptor12, _descriptor13, _descriptor14, _temp4, _class9, _descriptor15, _descriptor16, _temp5, _class11, _descriptor17, _temp6, _class13, _descriptor18, _temp7, _class15, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _class16, _temp8;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var SubmissionInfo = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(SubmissionInfo, _Component);

  function SubmissionInfo() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SubmissionInfo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubmissionInfo)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "start", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "end", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "shortLabel", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(SubmissionInfo, [{
    key: "render",
    value: function render() {
      if (this.start && this.end) {
        if (this.end < Date.now()) return _react.default.createElement("div", {
          className: "campaignClosed"
        }, this.shortLabel, " is closed");

        if (this.start > Date.now()) {
          return _react.default.createElement("div", {
            className: "campaignNotOpen"
          }, this.shortLabel, " is not yet accepting submissions");
        }

        return _react.default.createElement("p", {
          className: "campaignOpen withDate"
        }, _react.default.createElement("span", {
          className: "itemLabel"
        }, "Accepting submissions:"), _react.default.createElement("span", {
          className: "itemValue"
        }, (0, _moment.default)(this.start).format('MMMM DD, YYYY'), " - ", (0, _moment.default)(this.end).format('MMMM DD, YYYY')));
      }

      return _react.default.createElement("p", {
        className: "campaignOpen withoutDate"
      }, _react.default.createElement("span", {
        className: "itemLabel"
      }, "Now accepting submissions"));
    }
  }]);
  return SubmissionInfo;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "start", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "end", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "shortLabel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var PeopleSection = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(PeopleSection, _Component2);

  function PeopleSection() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, PeopleSection);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(PeopleSection)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "summary", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "people", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "description", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(PeopleSection, [{
    key: "render",
    value: function render() {
      if (this.people.length) {
        return _react.default.createElement("div", {
          className: "people-section"
        }, this.title && _react.default.createElement("h5", null, this.title), this.summary && _react.default.createElement("p", null, this.summary), _react.default.createElement(_PeopleBlockList.default, {
          people: this.people
        }), this.description && _react.default.createElement("div", {
          className: "description-text",
          dangerouslySetInnerHTML: {
            __html: this.description
          }
        }));
      }

      return null;
    }
  }]);
  return PeopleSection;
}(_react.Component), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var PrizesSection = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(PrizesSection, _Component3);

  function PrizesSection() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, PrizesSection);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(PrizesSection)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "title", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "summary", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "prizes", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "description", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(PrizesSection, [{
    key: "render",
    value: function render() {
      if (this.prizes.length) {
        return _react.default.createElement("div", {
          className: "prizes-section"
        }, this.title && _react.default.createElement("h5", null, this.title), this.summary && _react.default.createElement("p", null, this.summary), _react.default.createElement("div", {
          className: "prizes"
        }, this.prizes.map(function (prize) {
          return _react.default.createElement(Prize, _extends({
            key: prize.id
          }, prize));
        })), this.description && _react.default.createElement("div", {
          className: "description-text",
          dangerouslySetInnerHTML: {
            __html: this.description
          }
        }));
      }

      return null;
    }
  }]);
  return PrizesSection;
}(_react.Component), _temp3), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "prizes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
var Prize = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(Prize, _Component4);

  function Prize() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, Prize);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(Prize)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "title", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "description", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "image", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(Prize, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "prize"
      }, _react.default.createElement("div", {
        className: "prize-image"
      }, _react.default.createElement("div", {
        className: "image",
        style: {
          backgroundImage: "url(".concat(this.image, ")")
        }
      })), _react.default.createElement("div", {
        className: "prize-body"
      }, _react.default.createElement("div", {
        className: "prize-name"
      }, this.title), this.description && _react.default.createElement("div", {
        className: "prize-description",
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      })));
    }
  }]);
  return Prize;
}(_react.Component), _temp4), (_descriptor12 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
var DescriptionSection = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(DescriptionSection, _Component5);

  function DescriptionSection() {
    var _babelHelpers$getProt5;

    var _this5;

    babelHelpers.classCallCheck(this, DescriptionSection);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(DescriptionSection)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "description", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "title", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    return _this5;
  }

  babelHelpers.createClass(DescriptionSection, [{
    key: "render",
    value: function render() {
      if (this.description) {
        return _react.default.createElement("div", {
          className: "description-section"
        }, this.title && _react.default.createElement("h5", null, this.title), _react.default.createElement("div", {
          className: "description",
          dangerouslySetInnerHTML: {
            __html: this.description
          }
        }));
      }

      return null;
    }
  }]);
  return DescriptionSection;
}(_react.Component), _temp5), (_descriptor15 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);
var FeaturedItem = (_class11 = (_temp6 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(FeaturedItem, _Component6);

  function FeaturedItem() {
    var _babelHelpers$getProt6;

    var _this6;

    babelHelpers.classCallCheck(this, FeaturedItem);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt6 = babelHelpers.getPrototypeOf(FeaturedItem)).call.apply(_babelHelpers$getProt6, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "item", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(FeaturedItem, [{
    key: "render",
    value: function render() {
      var item = this.item;
      return _react.default.createElement("div", {
        className: "featured-item"
      }, _react.default.createElement("div", {
        className: "image-container"
      }, _react.default.createElement("a", {
        href: item.link
      }, _react.default.createElement("div", {
        className: "image",
        style: {
          backgroundImage: "url(".concat(item.image, ")")
        }
      }))), _react.default.createElement("div", {
        className: "content-container"
      }, _react.default.createElement("h3", null, _react.default.createElement("a", {
        href: item.link
      }, item.title)), item.submitter && _react.default.createElement("div", {
        className: "submitter"
      }, _react.default.createElement("div", {
        className: "image-container"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "image",
        noImageClassName: "initials",
        image: item.submitter.picture,
        name: item.submitter.name
      })), _react.default.createElement("div", {
        className: "content-container"
      }, _react.default.createElement("h4", null, item.submitter.link ? _react.default.createElement("a", {
        href: item.submitter.link
      }, item.submitter.name) : item.submitter.name), item.submitter.title && _react.default.createElement("h5", null, item.submitter.title))), item.description && _react.default.createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: item.description
        }
      })));
    }
  }]);
  return FeaturedItem;
}(_react.Component), _temp6), (_descriptor17 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class11);
var FeaturedSection = (_class13 = (_temp7 =
/*#__PURE__*/
function (_Component7) {
  babelHelpers.inherits(FeaturedSection, _Component7);

  function FeaturedSection() {
    var _babelHelpers$getProt7;

    var _this7;

    babelHelpers.classCallCheck(this, FeaturedSection);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt7 = babelHelpers.getPrototypeOf(FeaturedSection)).call.apply(_babelHelpers$getProt7, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "featured", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    return _this7;
  }

  babelHelpers.createClass(FeaturedSection, [{
    key: "render",
    value: function render() {
      if (this.featured && this.featured.items.length) {
        return _react.default.createElement("div", {
          className: "featured-section"
        }, this.featured.title && _react.default.createElement("h5", null, this.featured.title), this.featured.items.map(function (item) {
          return _react.default.createElement(FeaturedItem, {
            item: item,
            key: item.id
          });
        }));
      }

      return null;
    }
  }]);
  return FeaturedSection;
}(_react.Component), _temp7), (_descriptor18 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "featured", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class13);
var CampaignDetailsPage = (_class15 = (_temp8 = _class16 =
/*#__PURE__*/
function (_Component8) {
  babelHelpers.inherits(CampaignDetailsPage, _Component8);

  function CampaignDetailsPage() {
    var _babelHelpers$getProt8;

    var _this8;

    babelHelpers.classCallCheck(this, CampaignDetailsPage);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this8 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt8 = babelHelpers.getPrototypeOf(CampaignDetailsPage)).call.apply(_babelHelpers$getProt8, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this8, "shortLabel", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "submissionsStart", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "submissionsEnd", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "sections", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    return _this8;
  }

  babelHelpers.createClass(CampaignDetailsPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "block stack campaign-details-body"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, this.shortLabel && _react.default.createElement("h4", null, this.shortLabel), _react.default.createElement(SubmissionInfo, {
        start: this.submissionsStart,
        end: this.submissionsEnd,
        shortLabel: this.shortLabel
      }), this.sections.map(function (section, index) {
        var Type = CampaignDetailsPage.sectionTypes[section.type];
        if (!Type) return null;
        return _react.default.createElement(Type, _extends({
          key: index
        }, section));
      })));
    }
  }]);
  return CampaignDetailsPage;
}(_react.Component), _class16.sectionTypes = {
  description: DescriptionSection,
  people: PeopleSection,
  prizes: PrizesSection,
  featured: FeaturedSection
}, _temp8), (_descriptor19 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "shortLabel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "submissionsStart", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "submissionsEnd", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "sections", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class15);
exports.default = CampaignDetailsPage;